import { Slider } from "@material-ui/core"
import React, { useEffect, useRef, useState } from "react"
import { useToasts } from "react-toast-notifications"
import { getCategories, getProducts } from "../../utils/ApiRequests"
import { getApiErrorMessage } from "../../utils/ApiUtils"
import EventItemPreview from "../ItemPreview/EventItemPreview"
import FullLoader from "../Loaders/FullLoader"
import { AiFillCaretLeft, AiOutlineCaretRight } from "react-icons/ai"
import ModalContainer from "../ModalContainer/ModalContainer"
import DashboardItemPreview from "./DashboardItemPreview"
import CustomGifts from "./CustomGifts"
import CustomItemPreview from "../ItemPreview/CustomItemPreview"

const DashboardItems = ({
  products,
  addProduct,
  deleteProduct,
  registryId,
  contributions
}) => {
  const [filterProducts, setFilterProducts] = useState(products)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(true)
  const [productsList, setProductsList] = useState([])
  const [priceValue, setPriceValue] = useState([
    productsList?.minPrice,
    productsList?.maxPrice
  ])
  const ref = useRef()
  const [categoriesList, setCategoriesList] = useState([])
  const { addToast } = useToasts()
  const [showAddItem, setShowAddItem] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState("")
  const [customGift, setCustomGift] = useState(false)

  // console.log(ref)

  if (page < 1) {
    setPage(1)
  }
  const existingProducts = []
  // convert products in registry to an array that can be filtered
  products.forEach(p => existingProducts.push(p?.product._id))

  useEffect(() => {
    const { minPrice, maxPrice } = productsList || {}
    setFilterProducts(productsList?.products)
    setPriceValue([minPrice, maxPrice])
  }, [products, productsList])

  const handleValueChange = (event, newValue) => {
    setPriceValue(newValue)
    setFilterProducts(
      productsList?.products.filter(
        p => p?.price >= newValue[0] && p?.price <= newValue[1]
      )
    )
  }

  useEffect(() => {
    setLoading(true)
    getProducts(page)
      .then(res => {
        setProductsList(res.data.data)
        setLoading(false)
      })
      .catch(err => {
        setLoading(true)
      })

    getCategories()
      .then(res => setCategoriesList(res.data.data))
      .catch(err =>
        addToast(getApiErrorMessage(err?.response), { appearance: "error" })
      )
  }, [addToast, page])

  return (
    <div className="my-10 " ref={ref}>
      <div className="flex items-center mobiles:flex-col mobiles:gap-5 mobiles:items-start justify-between mb-10">
        <h1 className="font-bold text-xl ">Add items to your registry</h1>

        <button
          onClick={() => setCustomGift(true)}
          className=" py-2.5 px-11 bg-sbg-light-green text-transparent ml-3 rounded-lg text-base text-white mr-6 focus:outline-none"
        >
          Add a Custom Gift
        </button>
      </div>

      {customGift && (
        <CustomGifts
          closeModal={() => setCustomGift(false)}
          registryId={registryId[0]}
        />
      )}

      {loading && <FullLoader />}

      {showAddItem && (
        <ModalContainer>
          <DashboardItemPreview
            product={selectedProduct}
            closeModal={() => setShowAddItem(false)}
            addProduct={addProduct}
          />
        </ModalContainer>
      )}

      <div className="global-container">
        <p className="text-gray-600 mb-3 mt-6">Filters</p>

        <section className="flex">
          <div className="w-60 mobiles:hidden self-start p-5 mr-8 shadow rounded-md">
            <div className="py-4 border-b-2 border-gray-200 mb-2">
              <p className="text-gray-600">Multi Range</p>
              <div className="flex justify-between w-full mt-3 mb-6">
                <h2 className="text-gray-600 text-xs">
                  {productsList?.minPrice}
                </h2>
                <h2 className="text-gray-600 text-xs">
                  {productsList?.maxPrice}
                </h2>
              </div>

              <Slider
                valueLabelDisplay="auto"
                classes={{
                  root: "slider-root",
                  thumb: "slider-thumb",
                  valueLabel: "slider-value-label",
                  track: "slider-track",
                  rail: "slider-rail"
                }}
                value={priceValue}
                defaultValue={[productsList?.minPrice, productsList?.maxPrice]}
                min={productsList?.minPrice}
                max={productsList?.maxPrice}
                onChange={handleValueChange}
              />
            </div>

            {categoriesList.map((c, i) => (
              <div
                className="flex w-full items-center justify-between mb-2"
                key={i}
              >
                <input
                  type="radio"
                  className="w-1/12"
                  name="category"
                  onChange={() =>
                    setFilterProducts(
                      productsList?.products.filter(
                        p => p?.category[0] === c._id
                      )
                    )
                  }
                />
                <p className="w-10/12 text-sm text-gray-500">{c.name}</p>
              </div>
            ))}

            <div className="mt-5">
              <button
                style={{ backgroundColor: "#6F64F8", fontSize: "11px" }}
                className="px-3 block py-3 w-full text-center text-white rounded-bl-md"
                onClick={() => setFilterProducts(productsList?.products)}
              >
                CLEAR ALL FILTERS
              </button>
            </div>
          </div>

          <div className="flex-1">
            <div className=" mobiles:w-full mobiles:grid-cols-2 mobiles:gap-4 grid grid-cols-3 gap-10">
              {contributions?.map((c, i) => (
                <CustomItemPreview {...c} key={i} />
              ))}

              {filterProducts?.map((product, i) => (
                <EventItemPreview
                  product={product}
                  key={i}
                  inStore={existingProducts.includes(product._id)}
                  handleDelete={() => deleteProduct(product?._id)}
                  addToRegistry={() => {
                    setSelectedProduct(product)
                    setShowAddItem(true)
                  }}
                />
              ))}
            </div>{" "}
            <div className="w-32 mx-auto text-center my-3 py-5 flex items-center">
              <AiFillCaretLeft
                className=" text-xl mr-2"
                onClick={() => {
                  setPage(page - 1)
                  ref.current.scrollIntoView()
                }}
              />
              <button
                onClick={() => {
                  setPage(page - 1)
                  ref.current.scrollIntoView()
                }}
                className="mr-2"
              >
                {page}
              </button>

              {productsList?.totalPage !== page && (
                <>
                  <button
                    onClick={() => {
                      setPage(page + 1)
                      ref.current.scrollIntoView()
                    }}
                    className="ml-2"
                  >
                    {page + 1}
                  </button>

                  <AiOutlineCaretRight
                    className="text-xl ml-2"
                    onClick={() => {
                      setPage(page + 1)
                      ref.current.scrollIntoView()
                    }}
                  />
                </>
              )}
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default DashboardItems
